import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'

export const regionUrl = 'region/'

export interface RegionModel extends DjangoModel {
  expresId: string
  name: string
  isDefault: boolean
}

const {
  slice: RegionSlice,
  thunks: RegionThunks,
  adapter: RegionAdapter,
  selectors,
} = createGenericSlice<RegionModel>('region', regionUrl, {})

export const RegionAdapterExport = RegionAdapter

export const { selectById: selectRegionById, selectAll: selectAllRegions } =
  RegionAdapter.getSelectors<RootState>((state: RootState) => state.region)

export const { fetchById: fetchRegionById, fetchAll: fetchAllRegions } =
  RegionThunks
export const {
  selectLoading: selectRegionLoading,
  selectIsIdInProgress: selectIsRegionIdInProgress,
  selectError: selectSlotError,
  selectByIds: selectRegionsByIds,
} = selectors

export default RegionSlice.reducer
